import React, { useState } from "react";
import { Col, Row, Button, Tooltip, List, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { BankOutlined, CheckCircleOutlined } from "@ant-design/icons";
// component
import BranchBankDialog from "./dialog/branch_bank_dialog";
// redux
import { accountSelector } from "../../store/stripe/stripe.selector";

const BranchExternalAccount = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const branch = params?.id;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(false);
  // -------------------------- REDUX --------------------------
  const account = useSelector(accountSelector);
  const status = account?.individual?.verification?.status;
  const banks = account?.external_accounts?.data;
  const latestBanks = banks?.length > 0 ? [banks[0]] : [];
  const disabled = status !== "verified";
  console.log({ banks });
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row gutter={[16, 12]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Button
            type="primary"
            className="login-form-button form-button"
            style={{ marginBottom: 10 }}
            onClick={() => setDialog(true)}
            disabled={disabled}
            loading={loading}
          >
            Add Bank
          </Button>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          {renderBanks()}
        </Col>
      </Row>
    );
  };

  const renderBanks = () => {
    return (
      <List
        dataSource={latestBanks || []}
        bordered={true}
        renderItem={(item) => (
          <List.Item actions={[]}>
            <Skeleton avatar title={false} loading={item.loading} active>
              <List.Item.Meta
                avatar={<BankOutlined />}
                title={
                  <span>
                    {item?.account_holder_name} | {item?.bank_name} |{" "}
                    {item?.default_for_currency ? (
                      <Tooltip title="Default Payout Method">
                        <CheckCircleOutlined style={{ color: "green" }} />
                      </Tooltip>
                    ) : null}
                  </span>
                }
                description={
                  <span>
                    {item?.routing_number}...{item?.last4}
                  </span>
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 12]}>
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderBody()}
      </Col>
      <BranchBankDialog dialog={dialog} onClose={() => setDialog(false)} />
    </Row>
  );
};

export default BranchExternalAccount;
